import RenderProjects from "./ParallaxSliderRender";
import "./Project.scss";
import RenderProjectShowCase from "./AllProjects";

const Project = (props) => {
    return <section className="project__page">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="mylatestwork">
            <RenderProjects />
        </div>
        <RenderProjectShowCase />
    </section>
}

export default Project;
